import { Type } from "@sinclair/typebox";

import { RoleKeySchema } from "../schema.js";

export const SessionTokenSchema = Type.Object({
  "x-session-token": Type.String(),
});

export const SessionIdRequestParamsSchema = Type.Object({
  sessionId: Type.String(),
});

export const SessionResponseSchema = Type.Object({
  username: Type.String(),
  sessionId: Type.String(),
  sessionToken: Type.String(),
  lastLogin: Type.Optional(Type.String({ format: "date-time" })),
  expirationDate: Type.String({ format: "date-time" }),
  roles: RoleKeySchema,
});
